import React from "react";
import axios2 from 'services/axios2';
import AuthService from "services/auth.service";

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import  NuDropdown from "../../components/nubox/NuDropdown";
import  NuInput from "components/nubox/NuInput";
import cUtilFecha from "helpers/cUtilFecha"
import TriSwitch from "components/TriSwitch"


import { NotificationContainer, NotificationManager } from 'react-notifications';
import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

const cbo=[
  {  value:'1', label: 'label1', precio:0, color:"#ccc"},
  {  value:'2', label: 'Clss'},

]
let formInitial = {
  idd:0,
  ope:'n',
  id_asis: 'P',  
};

class AsisModal extends React.Component {
  

  state = {
    modalInsertar:false,
    id_tra:0,  /*maestro */
   
    form: formInitial,
        
    options: [  {value:'P', label:'Presente'},
      {value:'', label:'Falta'},
      {value:'L', label:'Licencia'},
    ]
    
  };
  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount Modal");
    //--limpiamos el array de prueba
    //this.setState({data:[]});
    
  }
  //---- retorna un formulario con valores iniciales
  limpiar = () =>{
    this.setState({form: formInitial});
  }
  //-------------------------

  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    
    //--- esto lo hacemos porque en vez de utilizar valores true, false
    //--- tenemos que utilizar 1, 0
    if(e.target.type==="checkbox"){
      //console.log("cheched:"+ e.target.checked);
      let res = e.target.checked? 1:0;
      //console.log("value:"+ res);
      
      this.setState({
        form:{
          ...this.state.form,
          [e.target.name]: res,
        }
      })
    }else{
      this.setState({
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      });
    }
  };
  //-------------------------------------------------------------- 
  //======================================================
  showModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: true});
  }
  closeModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: false});
  }

  //--------------- 
  //--- hora, solo se puede utilizar una ves setStare en una funcion 
  //--- cuando se utiliza multiples veces, solo hace caso la ultima, tomar en cuenta
  nuevo =() =>{
    console.log("nuevo");
    
    //this.limpiar();
    this.showModal();
    
    this.setState({
      form: {
        ...formInitial,
        "idd": 0,
        "ope":'n',
        
        "fecha": cUtilFecha.fechaActualMy()
      },
    });
    
    console.log(this.state.form);
    
  }
  //------------------------------------------------------
  //--------------------------------------
  validar = () =>{
    console.log("validar");
    console.log(this.state.form.fecha);
    if( this.state.form.fecha===''){
      toast.error( "Fecha no valida", {position: toast.POSITION.TOP_RIGHT});
      return true;
    }

    return false;
  }
  //-------------------------------------
  formSave = () => {
    // the item selected
    console.log("save");

    this.closeModal();
    this.props.okModal(this.state.form.id_asis); //callback

  }
  //-----------------------------------------------------------------------------------------------
  render() {
    const {form} = this.state;
    let clase ='';
    let titulo= '';
    let btnClass='primary';
    let btnText='Aceptar';
    switch(this.state.form.ope){
      case 'n': titulo='Selección '; clase='header-verde'; break;
      case 'e': titulo='Editar'; clase='header-naranja'; break;
      case 'x': titulo='Eliminar '; clase='header-rojo'; btnClass='danger'; btnText="Eliminar"; break;
      default: break;
    }
    return (
      <div>
        <ToastContainer />
        
        {/*--- modal---- */}
        <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} >
          <ModalHeader toggle={this.closeModal} className= { clase } 
          >
            <h4 className="modal-title">
            { titulo }
            </h4>
          </ModalHeader>

          <ModalBody style={{ background: "#F7F7F7"}}>
            
              <div>
              { 
              //  JSON.stringify(this.state.form) 
              } 
              </div>
              <br/>
              
              

              <div className="row mb-2">
                <div className="col-5">
                  <b>Marcar todos como:</b>
                </div>
                <div className="col-7">
                  <NuDropdown 
                    options={this.state.options}
                    name="id_asis"
                    value={this.state.form.id_asis}
                    onChange={this.handleChangeForm}
                  />
                </div>
              </div>

           
            
          </ModalBody>
          <ModalFooter>
            <Button color={ btnClass } onClick={ this.formSave}>{ btnText }</Button>
            {' '}
            <Button color="secondary" onClick={this.closeModal}>Cancelar</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
export default  AsisModal;